export  default {
    data(){
        return {
            key : 1,
            MIX_LINE_INTELLECT_BR : process.env.MIX_LINE_INTELLECT_BR
        }
    },
    methods:{
        next(index,key){
            let changed = this.$store.state.cv[key][index];
            let step = 1;
            if(
                (this.$store.state.cv[key][index + step].name !== undefined && this.$store.state.cv[key][index + step].name === process.env.MIX_LINE_INTELLECT_BR)
                ||
                (this.$store.state.cv[key][index + step].title !== undefined && this.$store.state.cv[key][index + step].title === process.env.MIX_LINE_INTELLECT_BR)
            ){
                step = 2;
            }
            this.$store.state.cv[key][index] = this.$store.state.cv[key][index + step];
            this.$store.state.cv[key][index + step] = changed;
            this.key++;
            this.$parent.$parent.changeKey()
        },
        prev(index,key){
            let changed = this.$store.state.cv[key][index];
            let step = 1;
            if(
                (this.$store.state.cv[key][index - step].name !== undefined && this.$store.state.cv[key][index - step].name === process.env.MIX_LINE_INTELLECT_BR)
                ||
                (this.$store.state.cv[key][index - step].title !== undefined && this.$store.state.cv[key][index - step].title === process.env.MIX_LINE_INTELLECT_BR)
            ){
                step = 2;
            }
            this.$store.state.cv[key][index] = this.$store.state.cv[key][index - step];
            this.$store.state.cv[key][index - step] = changed;
            this.key++;
            this.$parent.$parent.changeKey()
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/mixins/tools.js